const blogs = [
    {
        id: 1,
        title: "Introduction to Git and Github",
        link: "https://sanbal13.hashnode.dev/introduction-to-git-and-github-cke8drv97005is9s17g76cwfz",
        thumbnail: "images/blogs/Git_and_github.png",    
    },
    {
        id: 2,
        title: "Manipulating Array using sort() in JavaScript",
        link: "https://sanbal13.hashnode.dev/manipulating-array-using-sort-in-javascript-ckihc8toz00i580s13uqr7icm" ,
        thumbnail: "images/blogs/Array_sort.png",    
    },
    {
        id: 3,
        title: "Accessing Data sent by Client on the Server Side using Node.js",
        link: "https://sanbal13.hashnode.dev/accessing-data-sent-by-client-on-the-server-side-using-nodejs-ckpsty7f30e2ycls11rvt4oz8",
        thumbnail: "images/blogs/Accessing_data_on_the_server.png",    
    },    
];

export default blogs;